import React from "react";

import { Flex, ParagraphMd, RadioGroup, Select } from "@olist/design-system";

import { Input } from "../../../Input";

interface IInputHandlingProps {
  type: "text" | "radio" | "select" | "plaintext";
  label: string;
  id?: string;
  options?: { value: string; label: string }[];
  formData: Record<string, string>;
  handleFormDataChange: (data: Record<string, string>) => void;
}

export function InputHandling({
  formData,
  handleFormDataChange,
  id,
  label,
  options,
  type,
}: IInputHandlingProps) {
  function renderInput() {
    if (type === "plaintext") {
      return <ParagraphMd>{label}</ParagraphMd>;
    }

    if (type === "text") {
      return (
        <Input
          name={id as string}
          label={label}
          placeholder=""
          value={formData[id as string]}
          onChange={(e) =>
            handleFormDataChange?.({ [id as string]: e.target.value })
          }
        />
      );
    }

    if (type === "radio") {
      return (
        <>
          <label htmlFor={id}>{label}</label>
          <RadioGroup
            name={id as string}
            onChange={(e) =>
              handleFormDataChange?.({ [id as string]: e.target.value })
            }
            selectedRadio={formData[id as string]}
          >
            {(options ?? [])?.map((props) => (
              // eslint-disable-next-line react/prop-types
              <RadioGroup.Radio key={props?.value} {...props} />
            ))}
          </RadioGroup>
        </>
      );
    }

    if (type === "select") {
      return (
        <Select
          id={id}
          name={id}
          label={label}
          placeholder="Selecione uma opção"
          onSelect={(value) =>
            handleFormDataChange?.({ [id as string]: value?.[0]?.value })
          }
        >
          {(options ?? []).map((option) => (
            <Select.Option
              key={option.value}
              value={option.value}
              selected={formData[id as string] === option.value}
            >
              {option.label}
            </Select.Option>
          ))}
        </Select>
      );
    }

    return <>-</>;
  }

  return (
    <Flex flexDirection="column" mt="8px">
      {renderInput()}
    </Flex>
  );
}
